module.exports = __webpack_public_path__ + "img/home-banner2.60f92ce0.png";